import { apiClient, handleResponse } from '@/utils/axios-client'
import { z } from 'zod'

export interface ActivateUserRequest {
  token: string
  newPassword: string
}

export async function activateUser({
  token,
  newPassword
}: ActivateUserRequest): Promise<void> {
  return handleResponse(
    () =>
      apiClient.post('/api/v1/user-activations', {
        token,
        newPassword
      }),
    z.any()
  )
}
